/**
 * Per-browser anonymous voter token. Used so unauthenticated users can vote
 * without creating an account (one vote per browser).
 */
const KEY = 'mny_voter_token_v1';

function generate(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback
  return 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36) +
    Math.random().toString(36).slice(2);
}

export function getVoterToken(): string {
  if (typeof window === 'undefined') return '';
  try {
    let t = window.localStorage.getItem(KEY);
    if (!t || t.length < 8) {
      t = generate();
      window.localStorage.setItem(KEY, t);
    }
    return t;
  } catch {
    return generate();
  }
}
